module.exports = __webpack_public_path__ + "img/traverse-21.65f1c64e.png";